import { Question, QuestionTypeEnum } from '@/models/Question';
import { useCallback, useEffect, useState } from 'react';

type ModalView = 'editor' | 'create';

const useModalView = (currentQuestion?: Question) => {
  const [selectedType, selectTypology] = useState<QuestionTypeEnum | null>(
    currentQuestion?.type ?? null,
  );

  const reset = useCallback(() => {
    selectTypology(null);
  }, []);

  useEffect(() => {
    if (currentQuestion && currentQuestion.type !== selectedType)
      selectTypology(currentQuestion.type);
  }, [currentQuestion, selectedType]);

  const view: ModalView = selectedType ? 'editor' : 'create';

  return {
    view,
    selectedType,
    selectTypology,
    reset,
  };
};

export type { ModalView };
export default useModalView;
